import React, { useState } from "react";
import "./updatepsw.scss";
import Close from "@mui/icons-material/Close";
import {
  Lock,
  MailOutline,
  VisibilityOff,
  VisibilityOutlined,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { requestType } from "../../types/GlobalType";
import ErrorBar from "../../component/errorComp/ErrorBar.tsx";
import { accountService } from "../../_services/accountServices.js";
import { catchErrorApiCall } from "../../_services/apiUtils.js";
import MyLoading from "../../component/loader/MyLoading.tsx";
import user_api from "../../apiCaller/user.Caller.js";
import toast, { LoaderIcon } from "react-hot-toast";
import { AdminType } from "../../types/UserTypes.ts";

type Props = {
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  data: AdminType | undefined;
  dispatchReload: () => void;
};
const UpdatePswd = (props: Props) => {
  const [pswd, setpswd] = useState<string>("");
  const [errorMsg, setError] = useState<string>("");
  const [visible, setVisible] = useState<boolean>(false);
  const [type, setType] = useState<string>("password");
  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: null,
  });

  const navigate = useNavigate();

  const handleUpdate = async () => {
    if (!pswd?.toString().length) {
      return setState({
        ...state,
        errorMessage: "Veuiller compléter un mot de passe",
      });
    }

    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();
    if (!token) return navigate("/login");

    let userId = accountService.getUserImei();
    if (!userId) return navigate("/login");

    try {
      let data = { password: pswd };
      const response = await user_api.updatePassword(userId, data, token);
      if (response.data.status === 200) {
        toast.success("Mis à jour effectuée avec succes", { duration: 3000 });
        setpswd("");
        props.setOpen(false);
        props.dispatchReload();
      } else {
        toast.error("Une erreur s'est produite, réesayez plus tard", {
          style: {
            backgroundColor: "#630f0f", // Custom background color
            color: "white", // Text color
            fontSize: "12px", // Font size
            zIndex: 9999,
          },
        });
      }
    } catch (error) {
      setState({ ...state, isLoading: false });

      catchErrorApiCall(error);
    }
  };

  return (
    <>
      <MyLoading isLoading={state.isLoading} />
      <div className="update_pswd">
        <div className="dialog">
          <div className="header_pswd">
            <div className="header_left">
              <Lock />
              {"Modification mot de passe"}
            </div>
            <Close className="ico_close" onClick={() => props.setOpen(false)} />
          </div>
          {!!errorMsg && <ErrorBar title={errorMsg} />}
          <div className="body">
            {state.errorMessage && <ErrorBar title={state.errorMessage} />}
            <div className="label">
              <MailOutline className="ico" />
              <span>{props.data?.email}</span>
            </div>
            <div className="item ">
              <div className="inputContainer">
                <input
                  type={type}
                  placeholder={"Nouveau mot de passe "}
                  value={pswd}
                  onChange={(e) => setpswd(e.target.value)}
                />
                {visible ? (
                  <VisibilityOutlined
                    className="icoPas"
                    onClick={() => {
                      setType("password");
                      setVisible(false);
                    }}
                  />
                ) : (
                  <VisibilityOff
                    className="icoPas"
                    onClick={() => {
                      setType("text");
                      setVisible(true);
                    }}
                  />
                )}
              </div>
            </div>
            {state.isLoading ? (
              <button>
                <LoaderIcon />
              </button>
            ) : (
              <button onClick={handleUpdate}>Modifier</button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdatePswd;
